import { render, staticRenderFns } from "./ruChat.vue?vue&type=template&id=cf86bc94&scoped=true&lang=pug&"
import script from "./ruChat.vue?vue&type=script&lang=ts&"
export * from "./ruChat.vue?vue&type=script&lang=ts&"
import style0 from "./ruChat.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ruChat.vue?vue&type=style&index=1&id=cf86bc94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf86bc94",
  null
  
)

export default component.exports